import { cloneDeep } from "lodash-es";
import Utils from "../../../../util";
import { ResultRow } from "../../../data-structures/results/result-row.model";
import { CFIA } from "./cfia.model";
import { CFOA } from "./cfoa.model";

interface CashFlowInterface {
 'RESULTS.DATA.CASHFLOWS.CFOA'?: CFOA;
 'RESULTS.DATA.CASHFLOWS.CFIA'?: CFIA;
 'RESULTS.DATA.CASHFLOWS.CFFA'?: Record<string, ResultRow>;
 'RESULTS.DATA.CASHFLOWS.TITLE'?: CashFlowTotals;
}

export class CashFlow {
  'RESULTS.DATA.CASHFLOWS.CFOA';
  'RESULTS.DATA.CASHFLOWS.CFIA';
  'RESULTS.DATA.CASHFLOWS.CFFA';
  'RESULTS.DATA.CASHFLOWS.TITLE';
  get totals() {
    return this['RESULTS.DATA.CASHFLOWS.TITLE'];
  }
  set totals(value: CashFlowTotals) {
    this['RESULTS.DATA.CASHFLOWS.TITLE'] = value;
  }
  /** cash flows from financing activities */
  get cffa() {
    return this['RESULTS.DATA.CASHFLOWS.CFFA'];
  }
  set cffa(value: Record<string, ResultRow>) {
    this['RESULTS.DATA.CASHFLOWS.CFFA'] = value;
  }
  /** cash flows from operating activities */
  get cfoa() {
    return this['RESULTS.DATA.CASHFLOWS.CFOA']
  }
  set cfoa(value: CFOA) {
    this['RESULTS.DATA.CASHFLOWS.CFOA'] = value;
  }
  /** cash flows from investing activities */
  get cfia() {
    return this['RESULTS.DATA.CASHFLOWS.CFIA'];
  }
  set cfia(value: CFIA) {
    this['RESULTS.DATA.CASHFLOWS.CFIA'] = value;
  }

  constructor(param: CashFlowInterface = {}) {
    this['RESULTS.DATA.CASHFLOWS.TITLE'] = param['RESULTS.DATA.CASHFLOWS.TITLE']
      ? new CashFlowTotals(param['RESULTS.DATA.CASHFLOWS.TITLE'])
      : new CashFlowTotals();

    this['RESULTS.DATA.CASHFLOWS.CFIA'] = param['RESULTS.DATA.CASHFLOWS.CFIA']
      ? new CFIA(param['RESULTS.DATA.CASHFLOWS.CFIA'])
      : new CFIA();

    this['RESULTS.DATA.CASHFLOWS.CFOA'] = param['RESULTS.DATA.CASHFLOWS.CFOA']
      ? new CFOA(param['RESULTS.DATA.CASHFLOWS.CFOA'])
      : new CFOA();

    this['RESULTS.DATA.CASHFLOWS.CFFA'] = Utils.ObjectMapper(param['RESULTS.DATA.CASHFLOWS.CFFA'] || {}, Utils.toResultRows);
  }

  deepCopy() {
    return new CashFlow(cloneDeep(this));
  }
}

interface CashFlowTotalsInterface {
 'RESULTS.DATA.CASHFLOWS.NCF'?: ResultRow;
 'RESULTS.DATA.CASHFLOWS.CCF'?: ResultRow;
 'RESULTS.DATA.CASHFLOWS.DCF'?: ResultRow;
 'RESULTS.DATA.CASHFLOWS.DCCF'?: ResultRow;
}
class CashFlowTotals {
  'RESULTS.DATA.CASHFLOWS.NCF';
  'RESULTS.DATA.CASHFLOWS.CCF';
  'RESULTS.DATA.CASHFLOWS.DCF';
  'RESULTS.DATA.CASHFLOWS.DCCF';
  /** net cash flow */
  get ncf() {
    return this['RESULTS.DATA.CASHFLOWS.NCF'];
  }
  set ncf(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.NCF'] = value;
  }
  /** cumulative cash flow */
  get ccf() {
    return this['RESULTS.DATA.CASHFLOWS.CCF'];
  }
  set ccf(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.CCF'] = value;
  }
  /** discounted cash flow */
  get dcf() {
    return this['RESULTS.DATA.CASHFLOWS.DCF'];
  }
  set dcf(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.DCF'] = value;
  }
  /** discounted cumulative cash flow */
  get dccf() {
    return this['RESULTS.DATA.CASHFLOWS.DCCF'];
  }
  set dccf(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.DCCF'] = value;
  }
  constructor(param: CashFlowTotalsInterface = {}) {
    this['RESULTS.DATA.CASHFLOWS.NCF'] = param['RESULTS.DATA.CASHFLOWS.NCF']
    ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.NCF'])
    : new ResultRow();

    this['RESULTS.DATA.CASHFLOWS.CCF'] = param['RESULTS.DATA.CASHFLOWS.CCF']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.CCF'])
      : new ResultRow();

    this['RESULTS.DATA.CASHFLOWS.DCF'] = param['RESULTS.DATA.CASHFLOWS.DCF']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.DCF'])
      : new ResultRow();

    this['RESULTS.DATA.CASHFLOWS.DCCF'] = param['RESULTS.DATA.CASHFLOWS.DCCF']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.DCCF'])
      : new ResultRow();
  }

  deepCopy() {
    return new CashFlowTotals(cloneDeep(this));
  }
}